import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';
import { subscriptionService } from '@/services/subscription';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useSubscriptionEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        maxReceivableTime: '',
        cycleChip: 0
    });

    const validations = {
        name: { required },
        maxReceivableTime: { required, integer, minValue: minValue(1) },
        cycleChip: { required, integer, minValue: minValue(1) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => subscriptionService.item.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX })
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => subscriptionService.item.update(model.id, model.name, model.maxReceivableTime, model.cycleChip),
        onSuccess: () => router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX })
    });

    return { model, v$, fetch, update };
}
